import { render, staticRenderFns } from "./tkgl.vue?vue&type=template&id=0a66a540&"
import script from "./tkgl.vue?vue&type=script&lang=js&"
export * from "./tkgl.vue?vue&type=script&lang=js&"
import style0 from "./tkgl.vue?vue&type=style&index=0&id=0a66a540&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports